import { render, staticRenderFns } from "./CustomSwiper.vue?vue&type=template&id=330c8443&scoped=true&"
import script from "./CustomSwiper.vue?vue&type=script&lang=js&"
export * from "./CustomSwiper.vue?vue&type=script&lang=js&"
import style0 from "./CustomSwiper.vue?vue&type=style&index=0&id=330c8443&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330c8443",
  null
  
)

export default component.exports